import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { getPromoCodeStatus } from 'components/Admin/PromoCodes/utils/getPromoCodeStatus';

import { addMagritteNotification } from 'store/models/notification';
import { PromoCodeBound, PromoCodeDTO, updatePromoCode as updatePromoCodeAction } from 'store/models/promoCodes';
import { AppThunkAction } from 'store/utils';

export interface UpdatePromoCodeRequest {
    promoCode: string;
    description: string;
    startDate: string | null;
    endDate: string | null;
    activationsLimit: number | null;
    bound?: PromoCodeBound | null;
}

export const updatePromoCodeApi =
    (
        data: UpdatePromoCodeRequest,
        initialBound: PromoCodeBound | null,
        setIsLoading: (loading: boolean) => void,
        onSuccess: () => void
    ): AppThunkAction<Promise<void> | null> =>
    (dispatch) => {
        setIsLoading(true);
        const { promoCode, bound, ...body } = data;

        const requests = [fetcher.put(`/api/v1/backoffice/promo_codes/code/${promoCode}`, body)];

        if (bound || (initialBound && !bound)) {
            requests.push(
                bound
                    ? fetcher.put(`/api/v1/backoffice/promo_codes/code/${promoCode}/bound`, bound)
                    : fetcher.delete(`/api/v1/backoffice/promo_codes/code/${promoCode}/bound`)
            );
        }

        return Promise.all(requests)
            .then(async () => {
                const updatedPromoCode = await fetcher.get<unknown, PromoCodeDTO>(
                    `/api/v1/backoffice/promo_codes/code/${promoCode}`
                );
                dispatch([
                    updatePromoCodeAction({
                        ...updatedPromoCode,
                        status: getPromoCodeStatus(updatedPromoCode),
                    }),
                    addMagritteNotification(MagritteNotificationName.AdminUpdatePromoCodeSuccess),
                ]);
                onSuccess();
            })
            .catch(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.AdminUpdatePromoCodeError));
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
